import { render } from "./TendinousRegister.vue?vue&type=template&id=c6bdf7ae"
import script from "./TendinousRegister.vue?vue&type=script&lang=js"
export * from "./TendinousRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__